import type { Step } from '../types/step';
import { getAddMaintenanceReminderSteps } from '../common/addmaintenance';

/**
 * Steps for adding maintenance reminders
 */
export const AddMaintenanceReminderSteps: Step[] = getAddMaintenanceReminderSteps({
  flowFilter: (appData) => {
    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }
    return !!appData.selectedService?.insurance && !!appData.serviceSplitSelectedService?.garage;
  },
});
